'use strict';

angular.module('programme')

.component('article', {
    controller: 'ArticleCtrl',
    templateUrl: 'modules/programme/components/article.html',
    bindings: {
        model: '<'
    }
})

.controller('ArticleCtrl', function ($scope, $state)
{
    $scope.onClick = function(model)
    {
        $state.go('programme.category.article.page', {categorySlug: model.category.slug, articleSlug: model.slug});
    };
});
